import styled from 'styled-components';
import { Divider } from '@mui/material';

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 20px;
  border-bottom: 1px solid var(--tt-notion-like-editor-header-border);
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 8px;
`;

export const TitleText = styled.div<{ $editable?: boolean }>`
  font-size: 32px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.text.primary};
  flex: 1;
  cursor: ${({ $editable }) => ($editable ? 'pointer' : 'default')};
  padding: 4px 8px;
  margin: -4px -8px;
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme, $editable }) => ($editable ? theme.palette.action.hover : 'transparent')};
  }
`;

export const TitleActions = styled.div`
  display: flex;
  align-items: center;
`;

export const MetadataRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const MetadataLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.primary};
  min-width: 120px;
`;

export const MetadataValue = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.primary};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledDivider = styled(Divider)`
  margin-top: 16px;
`;

export const EditableValue = styled.span<{ $editable?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.primary};
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ $editable }) => ($editable ? 'pointer' : 'default')};
  padding: 4px 8px;
  margin: -4px -8px;
  border-radius: 4px;
  min-height: 24px;

  &:hover {
    background-color: ${({ theme, $editable }) => ($editable ? theme.palette.action.hover : 'transparent')};
  }
`;

export const EditContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

export const EditActions = styled.div`
  display: flex;
  align-items: center;
`;
